import { IExperienceWidgetQuery } from '../interfaces/experience-widget.query.interface';

export class ExperienceWidget {
    experianceName: string;
    id: string;
    name: string;
    description: string;
    type: string;

    constructor(query: IExperienceWidgetQuery) {
        this.experianceName = query.experience_name;
        this.id = query.id.toString();
        this.name = query.name;
        this.description = query.description;
        this.type = query.type;
    }
}
